type Breadcrumbs = {
  '@type': string;
  position: number;
  name?: string;
  item?: string;
};

const setListElements = (breadcrumbs: Breadcrumbs[]) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [...breadcrumbs],
});

export const addBreadcrumbsJsonLd = (breadcrumbs: Breadcrumbs[]) => ({
  __html: JSON.stringify(setListElements(breadcrumbs)),
});
